import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import Home from "./components/Home";
import PropertyDetails from "./pages/PropertyDetails";
import PropertyList from "./pages/StayList";
import AuthPage from "./pages/AuthPage";
import LoginForm from "./pages/LoginForm";
import ProfilePage from "./pages/ProfilePage";
import PropertyPage from "./pages/MyPropertiesPage";
import MyBookingPage from "./pages/MyBookingPage";
import MyBookingByOwnerPage from "./pages/MyBookingByOwnerPage";
import BookingDetailsPage from "./pages/BookingDetailsPage";
import BookingReviewPage from "./pages/BookingReviewPage";
import BookingSuccess from "./pages/BookingSuccess";
import PropertyUploadPage from "./pages/PropertyUploadPage";
import ProtectedOwnerRoute from "./components/ProtectedOwnerRoute";
import PropertyBookingsPage from "./pages/PropertyBookingsPage";
import PropertyBookingDetailsPage from "./pages/PropertyBookingDetailsPage";
import ForgotPassword from "./pages/ForgotPasswordPage";
import ResetPassword from "./pages/ResetPasswordPage";
import Aboutpage from "./pages/Aboutpage";
import Contactpage from "./pages/Contactpage";
import Careerpage from "./pages/Careerpage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatPage from "./pages/ChatPage";
import MessagesPage from "./pages/MyMessagesPage";
import SubscriptionPage from "./pages/MySubscriptionPage";
import ScrollToTop from "./components/ScrollToTop";
import PageViewTracker from "./components/PageViewTracker";
import BankPage from "./pages/MyBanksPage";
import MyInventoryPage from "./pages/MyInventoryPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import PaymentSuccess from "./pages/payment-success";
import HelpCenterPage from "./pages/HelpCenterPage";
import HelpArticleDetailPage from "./pages/HelpArticleDetailPage";

function App() {
  return (
    // Wrap entire app with GoogleOAuthProvider
    <GoogleOAuthProvider clientId="587478390570-96702uhc4ppgelf1teirmajp057kpqsb.apps.googleusercontent.com">
      <Router>
        <ScrollToTop />
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contactpage />} />
          <Route path="/about" element={<Aboutpage />} />
          <Route path="/career" element={<Careerpage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms-conditions" element={<TermsPage />} />
          <Route path="/help-center" element={<HelpCenterPage />} />
          <Route path="/help-center/:slug" element={<HelpArticleDetailPage />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
          <Route path="/stays" element={<PropertyList />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<AuthPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/my-banks" element={<BankPage />} />
          <Route path="/mybookings" element={<MyBookingPage />} />
          <Route path="/mybookings-owner" element={<MyBookingByOwnerPage />} />
          <Route path="/my-properties" element={<PropertyPage />} />
          <Route path="/my-messages" element={<MessagesPage />} />
          <Route path="/my-subscription" element={<SubscriptionPage />} />
          <Route path="/my-property-bookings" element={<PropertyBookingsPage />} />
          <Route path="/my-inventory" element={<MyInventoryPage />} />
          <Route path="/booking-details/:bookingId" element={<BookingDetailsPage />} />
          <Route path="/property-booking-details/:bookingId" element={<PropertyBookingDetailsPage />} />
          <Route path="/booking/review" element={<BookingReviewPage />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/chat/:chatId" element={<ChatPage />} />

          {/* Protect upload-property route */}
          <Route path="/upload-property" element={<ProtectedOwnerRoute> <PropertyUploadPage /> </ProtectedOwnerRoute>} />
        </Routes>

        {/* Global Toast Container — appears once for entire app */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
